import { Component, Input, OnInit } from '@angular/core';
import { MovieModel } from '../../core/interfaces/movie.model';

@Component({
  selector: 'app-ui-movies-grid',
  templateUrl: './ui-movies-grid.component.html',
  styleUrls: ['./ui-movies-grid.component.scss']
})
export class UiMoviesGridComponent implements OnInit {
  @Input() movies: MovieModel[] = [];
  @Input() title: String;
  @Input() felixoliver: boolean = false;

  constructor() { }

  ngOnInit(): void {
    // console.log("movies", this.movies);
  }

}
